import { createFileRoute } from "@tanstack/react-router";

import { AdminAdministratorsPage } from "@/components/admin/AdminAdministratorsPage";

export const Route = createFileRoute("/administrator/administrators")({
  component: AdminAdministratorsPage,
});
